module.exports = __webpack_public_path__ + "img/step-by-step-3.4147e297.jpg";